import styled from '@emotion/styled';
import type { PropsWithChildren } from 'react';

import { Box, type BoxProps, getBoxStyles } from '../box/Box';
import { breakpoints } from '../theme/media';
import { themeStyles, themeVars } from '../theme/theme';

export type DisplayCardProps = BoxProps & {
  title?: string;
  subtitle?: string;
  className?: string;
  actions?: React.ReactNode;
};

const Component = ({
  children,
  title,
  subtitle,
  className,
  actions,
}: PropsWithChildren<DisplayCardProps>) => {
  return (
    <Root className={className}>
      {(title || actions || subtitle) && (
        <Header>
          <HeaderLeft>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </HeaderLeft>
          {actions && <Actions>{actions}</Actions>}
        </Header>
      )}
      {children}
    </Root>
  );
};

const Header = styled.div`
  margin: 12px 16px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${breakpoints.before.laptop} {
    flex-direction: column;
    gap: 16px;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  ${themeStyles.text.ellipsis};
  ${themeStyles.text.telkaEx.body.xs};
  color: ${themeVars.colors.coldGrey550};
`;

const Subtitle = styled.div`
  ${themeStyles.text.ellipsis};
  ${themeStyles.text.telka.body.xs};
  color: ${themeVars.colors.coldGrey550};
`;

const Actions = styled.div``;

const Root = styled.div`
  ${getBoxStyles};

  width: ${(p) => p.w || '100%'};
  height: ${(p) => p.h || '100%'};
  padding: 4px;
  border-radius: 8px;
  background: ${themeVars.colors.titan100};
  display: flex;
  flex-direction: column;
`;

const Content = styled(Box)`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${themeVars.colors.titan200};
  background: ${themeVars.colors.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  width: ${(p) => p.w || '100%'};
`;

export const DisplayCard = Object.assign(Component, {
  Root,
  Header,
  HeaderLeft,
  Title,
  Subtitle,
  Actions,
  Content,
});
